<template>
  <div class="spinner-container">
    <ProgressSpinner
      style="width: 50px; height: 50px"
      strokeWidth="5"
      fill="var(--surface-ground)"
      animationDuration=".5s"
      aria-label="Custom ProgressSpinner"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import { useAuthStore } from "@/store/modules/auth";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "LoginCallback",

  setup() {
    const authStore = useAuthStore();
    const router = useRouter();

    onMounted(() => {
      authStore.onLoginCallback().then(() => {
        router.push("/accueil");
      });
    });

    return {};
  },
});
</script>

<style src="./login-callback.scss" lang="scss" scoped />
